import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
const _excluded = ["action"];
import { useCallback, useEffect, useRef } from 'react';
import { searchDomainSearchResultView, searchDomainClickGetIt, domainGatePageClickSrc17Evid975, domainsConciergeClickOnSuggestedTld, vUpgradeBeforeConnect, searchDomainTransferInPopUp, entriIntroModal, entriEligibilityLittleHelper, entriFlowLeaveFunnel, entriFlowResult, entriStepView, conciergeViewIOwnClick, domainSearchSearchSrc17Evid1052, domainSearchSearchResultsSrc17Evid1053, domainSearchSuggestionsSrc17Evid1054, domainSearchSuggestionViewedSrc17Evid1317, domainsDomainsGatePageLoadSrc17Evid1055, domainsDomainsGateResultPageLoadSrc17Evid1056, domainsSearchGateLoadSrc17Evid1097, whoIsViewSrc17Evid20100, whoIsGeneralActionSrc17Evid20101, whoIsAboveTheFoldImpressionSrc17Evid20103, bngGeneralActionSrc17Evid20201, bngViewModalSrc17Evid20210, bngBusinessNamesShown, domainsGateClickOnTldSrc17Evid1180, domainsGateScrollSrc17Evid1181 } from '@wix/bi-logger-premium-data-domains/v2';
import { CoreDomainSearchStore, DomainSearchSuiteModule, EntriIntroModalModule, EntriModule } from '@wix/domains-search-suite';
import { usePremiumEssentialsContext } from '@wix/premium-fed-sdk/@premium-essentials';
import { DomainsApiClient } from '@wix/domains-serverless-interface/react-kit';
import { isValidDomain } from '@wix/domains-serverless-interface';
import { ViewMode } from '../types';
import { EntriFlowStatus } from '@wix/domains-serverless-interface';
import { DomainSearchGateModule } from '../module/domainSearchGate.module';
import { gateBiDedupService } from './gateBiDedupService';
import { mapResultToDomainAvailabilityStatus } from '../utils/domainAvailabilityStatusMap';
import { resolveSitenameBi } from '../utils/siteName';
import { tldClickSearchService } from './tldClickSearchService';
import { useIsMobile } from './useIsMobile';
import { searchDomainResultPageErrorSrc17Evid506, shouldReport1054, elapsedSince, nowMs, resolveSearchOrigin, resolveViewPage } from './useDomainSearchGateBi.utils';
const generateGuid = () => {
  return crypto.randomUUID();
};
const REFERRAL_FOCUS_WIDGET = 'dashboard-focus-widget';

/**
 * Counts the number of active (non-query) filters.
 */
const countActiveFilters = submittedFilters => {
  if (!submittedFilters) {
    return 0;
  }
  return Object.entries(submittedFilters).filter(_ref => {
    let key = _ref[0],
      val = _ref[1];
    return key !== 'query' && val != null && val !== '' && !(Array.isArray(val) && val.length === 0);
  }).length;
};

/**
 * Fires 1052 (Domain Search) if the search term hasn't been reported yet.
 * Called from both onSearchResultLoad (TLD searches) and onResultsPageLoad
 * (bare-term searches), but the singleton dedup service ensures it only
 * fires once per unique search term.
 *
 * On the initial Gate landing from the Focus Widget we suppress 1052
 * (the widget already fired its own) but still consume the dedup term so
 * a racing handler for the same search can't fire a duplicate.  On
 * subsequent searches (isOnResultsPage = true) the suppression is
 * bypassed and 1052 fires normally for every new term.
 */
const tryReport1052 = (biLogger, params, isOnResultsPage) => {
  if (!isOnResultsPage && params.referralAdditionalInfo === REFERRAL_FOCUS_WIDGET) {
    gateBiDedupService.shouldFire1052(params.searchTerm);
    return;
  }
  if (!gateBiDedupService.shouldFire1052(params.searchTerm)) {
    return;
  }
  biLogger == null || biLogger.report(domainSearchSearchSrc17Evid1052({
    searchTerm: params.searchTerm,
    searchOrigin: params.searchOrigin,
    msid: params.msid,
    isPremiumSite: params.isPremiumSite,
    activeFilters: params.activeFilters,
    numFiltersActive: params.numFiltersActive,
    url: window.location.href,
    pageSource: document.referrer,
    referralAdditionalInfo: params.referralAdditionalInfo,
    sitename: params.sitename,
    isTldClick: tldClickSearchService.isTldClick(params.searchTerm)
  }));
};
export const useDomainSearchGateBi = _ref2 => {
  let viewMode = _ref2.viewMode,
    _ref2$reportGatePageL = _ref2.reportGatePageLoadEvents,
    reportGatePageLoadEvents = _ref2$reportGatePageL === void 0 ? true : _ref2$reportGatePageL,
    _ref2$useReferralAddi = _ref2.useReferralAdditionalInfoAsSearchOrigin,
    useReferralAdditionalInfoAsSearchOrigin = _ref2$useReferralAddi === void 0 ? false : _ref2$useReferralAddi,
    _ref2$deferResultsPag = _ref2.deferResultsPageLoad,
    deferResultsPageLoad = _ref2$deferResultsPag === void 0 ? false : _ref2$deferResultsPag,
    _ref2$isResultsVisibl = _ref2.isResultsVisible,
    isResultsVisible = _ref2$isResultsVisibl === void 0 ? true : _ref2$isResultsVisibl,
    bngMobileSearchTerm = _ref2.bngMobileSearchTerm,
    pageType = _ref2.pageType,
    isEmptyState = _ref2.isEmptyState,
    prefilledTld = _ref2.prefilledTld;
  const isGateLanding = pageType ? pageType === 'landing' : viewMode === ViewMode.GATE || viewMode === ViewMode.ACCOUNT_LEVEL_GATE || viewMode === ViewMode.FUNNEL_GATE;
  const gateGuidRef = useRef(generateGuid());
  const isOnResultsPageRef = useRef(false);
  const biHandlerGenRef = useRef(0);
  const lastFiredSearchGenRef = useRef(-1);
  const lastFired1054GenRef = useRef(-1);
  const resultsPageLoadFiredRef = useRef(false);
  const lastSuggestionsPageRef = useRef(1);
  const _usePremiumEssentials = usePremiumEssentialsContext(),
    siteId = _usePremiumEssentials.siteId,
    siteName = _usePremiumEssentials.siteName,
    biLogger = _usePremiumEssentials.biLogger,
    referralAdditionalInfo = _usePremiumEssentials.referralAdditionalInfo;
  const isMobile = useIsMobile();
  const _DomainsApiClient$hoo = DomainsApiClient.hooks.useDomainsAccount({}, viewMode !== ViewMode.BASE44),
    accountData = _DomainsApiClient$hoo.data;
  const _DomainsApiClient$use = DomainsApiClient.useQueries(),
    canPurchaseDomainSuite = _DomainsApiClient$use.canPurchaseDomainSuite;
  const submittedFilters = CoreDomainSearchStore == null ? void 0 : CoreDomainSearchStore.useSubmittedFilters();
  const accountDataRef = useRef(accountData);
  const siteIdRef = useRef(siteId);
  const submittedFiltersRef = useRef(submittedFilters);
  const mountedRef = useRef(false);
  const searchSubmittedAtRef = useRef(undefined);
  const lastAnchoredTermRef = useRef(undefined);
  accountDataRef.current = accountData;
  siteIdRef.current = siteId;
  submittedFiltersRef.current = submittedFilters;
  if ((submittedFilters == null ? void 0 : submittedFilters.query) !== lastAnchoredTermRef.current) {
    lastAnchoredTermRef.current = submittedFilters == null ? void 0 : submittedFilters.query;
    searchSubmittedAtRef.current = submittedFilters != null && submittedFilters.query ? nowMs() : undefined;
  }
  const getCommonParams = useCallback(() => {
    var _accountDataRef$curre, _accountDataRef$curre2, _accountDataRef$curre3, _accountDataRef$curre4, _accountDataRef$curre5;
    return {
      searchTerm: submittedFilters == null ? void 0 : submittedFilters.query,
      keyWords: submittedFilters == null ? void 0 : submittedFilters.keywords,
      style: submittedFilters == null ? void 0 : submittedFilters.style,
      activeFilters: JSON.stringify(submittedFilters),
      isPremiumSite: (_accountDataRef$curre = accountDataRef.current) == null ? void 0 : _accountDataRef$curre.isPremiumSite,
      isPremium: (_accountDataRef$curre2 = accountDataRef.current) == null ? void 0 : _accountDataRef$curre2.isPremiumSite,
      referralAdditionalInfo: referralAdditionalInfo || viewMode,
      msid: siteIdRef.current,
      viewMode,
      gateGuid: gateGuidRef.current,
      isSale: (_accountDataRef$curre3 = accountDataRef.current) == null ? void 0 : _accountDataRef$curre3.isPremiumPlansOnSale,
      voucher: (_accountDataRef$curre4 = accountDataRef.current) != null && _accountDataRef$curre4.hasValidVouchers ? 'true' : 'false',
      hasValidVouchers: (_accountDataRef$curre5 = accountDataRef.current) != null && _accountDataRef$curre5.hasValidVouchers ? 'true' : 'false',
      pageSource: document.referrer
    };
  }, [referralAdditionalInfo, submittedFilters, viewMode]);
  useEffect(() => {
    const commonParams = getCommonParams();
    const biGen = ++biHandlerGenRef.current;
    const searchStartedOnResultsPage = isOnResultsPageRef.current;
    const _resolveSitenameBi = resolveSitenameBi(siteName),
      sitename = _resolveSitenameBi.sitename,
      sitenameType = _resolveSitenameBi.sitenameType;

    // 1180/1181 share 1097's page context so gate clicks and scrolls join to
    // gate loads on the same view_page vocabulary.
    const gateEventContext = {
      pageType: isGateLanding ? 'Search' : 'Results',
      viewPage: resolveViewPage(viewMode, !isGateLanding),
      referralAdditionalInfo: commonParams.referralAdditionalInfo,
      msid: commonParams.msid,
      url: window.location.href,
      deviceType: isMobile ? 'mobile' : 'desktop'
    };

    // 1053/1054 attribution: searchOrigin + pageSource + referralAdditionalInfo,
    // as 1052 already does.
    const withResultsAttribution = params => {
      return {
        ...params,
        searchOrigin: resolveSearchOrigin({
          isOnResultsPage: searchStartedOnResultsPage,
          referralAdditionalInfo,
          viewMode,
          useReferralAdditionalInfoAsSearchOrigin
        }),
        pageSource: document.referrer || undefined,
        referralAdditionalInfo
      };
    };
    DomainSearchGateModule.SDK.setBiEvent('onGatePageLoad', () => {
      if (reportGatePageLoadEvents) {
        biLogger == null || biLogger.report(domainsDomainsGatePageLoadSrc17Evid1055({
          msid: commonParams.msid,
          referralAdditionalInfo: commonParams.referralAdditionalInfo,
          sitename
        }));
      }
      biLogger == null || biLogger.report(domainsSearchGateLoadSrc17Evid1097({
        pageType: 'Search',
        msid: commonParams.msid,
        referralAdditionalInfo: commonParams.referralAdditionalInfo,
        view_page: resolveViewPage(viewMode, false),
        url: window.location.href,
        sitename,
        sitenameType
      }));
    });
    if (!mountedRef.current) {
      mountedRef.current = true;
      if (isGateLanding) {
        DomainSearchGateModule.internals.bi.onGatePageLoad == null || DomainSearchGateModule.internals.bi.onGatePageLoad({
          ...commonParams
        });
      }
    }
    if (!isGateLanding && !resultsPageLoadFiredRef.current && (!deferResultsPageLoad || isResultsVisible)) {
      resultsPageLoadFiredRef.current = true;
      if (reportGatePageLoadEvents) {
        biLogger == null || biLogger.report(domainsDomainsGateResultPageLoadSrc17Evid1056({
          msid: commonParams.msid,
          referralAdditionalInfo: commonParams.referralAdditionalInfo,
          sitename,
          isEmptyState,
          prefilledTld
        }));
      }
      biLogger == null || biLogger.report(domainsSearchGateLoadSrc17Evid1097({
        pageType: 'Results',
        msid: commonParams.msid,
        referralAdditionalInfo: commonParams.referralAdditionalInfo,
        view_page: resolveViewPage(viewMode),
        url: window.location.href,
        sitename,
        sitenameType,
        isEmptyState,
        prefilledTld
      }));
    }
    if (bngMobileSearchTerm) {
      const bngFilters = submittedFiltersRef.current;
      tryReport1052(biLogger, {
        searchTerm: bngMobileSearchTerm,
        searchOrigin: resolveSearchOrigin({
          isOnResultsPage: true,
          referralAdditionalInfo,
          viewMode,
          useReferralAdditionalInfoAsSearchOrigin
        }),
        msid: commonParams.msid,
        isPremiumSite: commonParams.isPremiumSite,
        activeFilters: JSON.stringify(bngFilters),
        numFiltersActive: countActiveFilters(bngFilters),
        referralAdditionalInfo,
        sitename
      }, true);
    }
    DomainSearchGateModule.SDK.setBiEvent('onResultsPageLoad', params => {
      var _params$suggestions, _params$suggestions2;
      biLogger == null || biLogger.report(searchDomainSearchResultView({
        ...commonParams,
        suggestions: JSON.stringify((_params$suggestions = params.suggestions) == null ? void 0 : _params$suggestions.map(sug => ({
          domain: sug.domain,
          isPremium: sug.isPremiumDomain,
          in_hero_card: sug.inHeroCard
        }))),
        type: params.type,
        result: params.result
      }));

      // 1052: fire before generation guard using ref for fresh search term.
      // gateBiDedupService.shouldFire1052 handles per-term dedup.
      // On subsequent searches (isOnResultsPage) bypass the focus-widget
      // suppression so 1052 fires for every new search term.
      if (params.type === 'suggestions') {
        const freshFilters = submittedFiltersRef.current;
        const freshSearchTerm = freshFilters == null ? void 0 : freshFilters.query;
        const numFiltersActive = countActiveFilters(freshFilters);
        tryReport1052(biLogger, {
          searchTerm: freshSearchTerm,
          searchOrigin: resolveSearchOrigin({
            isOnResultsPage: isOnResultsPageRef.current,
            referralAdditionalInfo,
            viewMode,
            useReferralAdditionalInfoAsSearchOrigin
          }),
          msid: commonParams.msid,
          isPremiumSite: commonParams.isPremiumSite,
          activeFilters: JSON.stringify(freshFilters),
          numFiltersActive,
          referralAdditionalInfo,
          sitename
        }, isOnResultsPageRef.current);
      }
      if (!shouldReport1054({
        biGen,
        handlerGen: biHandlerGenRef.current,
        lastFiredGen: lastFired1054GenRef.current,
        pageNumber: params.pageNumber,
        lastFiredPage: lastSuggestionsPageRef.current
      })) {
        return;
      }
      if (params.type === 'suggestions' && gateBiDedupService.shouldFire1054(commonParams.searchTerm, ((_params$suggestions2 = params.suggestions) == null ? void 0 : _params$suggestions2.length) ?? 0, params.pageNumber)) {
        var _params$suggestions3;
        lastFired1054GenRef.current = biGen;
        lastSuggestionsPageRef.current = params.pageNumber ?? 1;
        const numFiltersActive = countActiveFilters(submittedFilters);
        biLogger == null || biLogger.report(domainSearchSuggestionsSrc17Evid1054(withResultsAttribution({
          searchTerm: commonParams.searchTerm,
          // Gate renders must carry the gate variant of view_page — the
          // suggestions render on the landing page, not the results page.
          viewPage: resolveViewPage(viewMode, !isGateLanding),
          sitename,
          isTldClick: tldClickSearchService.isTldClick(commonParams.searchTerm),
          suggestions: JSON.stringify((_params$suggestions3 = params.suggestions) == null ? void 0 : _params$suggestions3.map(sug => ({
            domain: sug.domain,
            isPremium: sug.isPremiumDomain,
            in_hero_card: sug.inHeroCard
          }))),
          msid: commonParams.msid,
          isPremiumSite: commonParams.isPremiumSite,
          activeFilters: commonParams.activeFilters,
          numFiltersActive,
          url: window.location.href,
          hero_card_offers: params.hero_card_offers,
          pageNumber: params.pageNumber ?? 1
        })));
      }
    });

    // 17:506 — suggestions failed to deliver results for an active search;
    // fires instead of 1054 (the dedup service enforces the exclusivity and
    // the empty-term guard keeps page-load default-suggestion failures out).
    DomainSearchGateModule.SDK.setBiEvent('onResultsPageError', params => {
      var _submittedFiltersRef$;
      const freshSearchTerm = (_submittedFiltersRef$ = submittedFiltersRef.current) == null ? void 0 : _submittedFiltersRef$.query;
      if (!gateBiDedupService.shouldFire506(freshSearchTerm, params.errorType)) {
        return;
      }
      biLogger == null || biLogger.report(searchDomainResultPageErrorSrc17Evid506({
        ErrorType: params.errorType,
        ErrorSubtype: params.errorSubtype,
        SearchTerm: freshSearchTerm,
        TriggerType: 'search',
        SearchOrigin: resolveSearchOrigin({
          isOnResultsPage: isOnResultsPageRef.current,
          referralAdditionalInfo,
          viewMode,
          useReferralAdditionalInfoAsSearchOrigin
        })
      }));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onSearchResultLoad', params => {
      biLogger == null || biLogger.report(searchDomainSearchResultView({
        ...commonParams,
        ...params,
        IsPremiumDomain: params.isPremiumDomain
      }));

      // 1052: fire before generation guard using ref for fresh search term.
      // gateBiDedupService.shouldFire1052 handles per-term dedup.
      // On subsequent searches (isOnResultsPage) bypass the focus-widget
      // suppression so 1052 fires for every new search term.
      const freshFilters = submittedFiltersRef.current;
      const freshSearchTerm = freshFilters == null ? void 0 : freshFilters.query;
      const numFilters = countActiveFilters(freshFilters);
      tryReport1052(biLogger, {
        searchTerm: freshSearchTerm,
        searchOrigin: resolveSearchOrigin({
          isOnResultsPage: isOnResultsPageRef.current,
          referralAdditionalInfo,
          viewMode,
          useReferralAdditionalInfoAsSearchOrigin
        }),
        msid: commonParams.msid,
        isPremiumSite: commonParams.isPremiumSite,
        activeFilters: JSON.stringify(freshFilters),
        numFiltersActive: numFilters,
        referralAdditionalInfo,
        sitename
      }, isOnResultsPageRef.current);
      if (biGen !== biHandlerGenRef.current || lastFiredSearchGenRef.current >= biGen) {
        isOnResultsPageRef.current = true;
        return;
      }
      lastFiredSearchGenRef.current = biGen;
      if (params.result && isValidDomain(commonParams.searchTerm ?? '') && gateBiDedupService.shouldFire1053(commonParams.searchTerm)) {
        const numFiltersActive = countActiveFilters(submittedFilters);
        biLogger == null || biLogger.report(domainSearchSearchResultsSrc17Evid1053(withResultsAttribution({
          searchTerm: commonParams.searchTerm,
          result: mapResultToDomainAvailabilityStatus(params.result),
          viewPage: resolveViewPage(viewMode),
          sitename,
          isTldClick: tldClickSearchService.isTldClick(commonParams.searchTerm),
          msid: commonParams.msid,
          isPremiumSite: commonParams.isPremiumSite,
          activeFilters: commonParams.activeFilters,
          numFiltersActive,
          url: window.location.href
        })));
      }
      isOnResultsPageRef.current = true;
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onDomainIsTakenAction', params => {
      biLogger == null || biLogger.report(conciergeViewIOwnClick({
        ...commonParams,
        ...params,
        domain: params.domainName
      }));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onGetItClick', async params => {
      const _await$canPurchaseDom = await canPurchaseDomainSuite({
          domain: params.domain
        }),
        premium = _await$canPurchaseDom.premium;
      biLogger == null || biLogger.report(searchDomainClickGetIt({
        ...commonParams,
        position: params.position,
        domain: params.domain,
        type: params.type || 'suggestion',
        IsPremiumDomain: premium
      }));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onCTAClick', params => {
      biLogger == null || biLogger.report(domainGatePageClickSrc17Evid975({
        ...commonParams,
        search_term: commonParams.searchTerm,
        ctaClick: params.ctaClick,
        pageNumber: params.ctaClick === 'show_more_results' ? lastSuggestionsPageRef.current + 1 : undefined,
        value: params.value,
        domain: params.domain,
        position: params.position,
        type: params.type,
        device_type: params.deviceType
      }));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onSuggestionViewed', params => {
      biLogger == null || biLogger.report(domainSearchSuggestionViewedSrc17Evid1317({
        searchTerm: commonParams.searchTerm,
        domain: params.domain,
        position: params.position,
        pageNumber: params.pageNumber,
        isPremium: params.isPremium,
        timeToViewMs: elapsedSince(searchSubmittedAtRef.current)
      }));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onSelectTld', params => {
      biLogger == null || biLogger.report(domainsConciergeClickOnSuggestedTld(params));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onUpgradeModal', params => {
      biLogger == null || biLogger.report(vUpgradeBeforeConnect({
        ...commonParams,
        ...params
      }));
    });
    DomainSearchSuiteModule.SDK.setBiEvent('onTransferModal', _ref3 => {
      let action = _ref3.action,
        params = _objectWithoutPropertiesLoose(_ref3, _excluded);
      biLogger == null || biLogger.report(searchDomainTransferInPopUp({
        ...commonParams,
        actionName: action,
        domain: params.domainName,
        ...params
      }));
    });
    EntriIntroModalModule.SDK.setBiEvent('onEntriIntroModal', _ref4 => {
      let action = _ref4.action,
        domainName = _ref4.domainName;
      biLogger == null || biLogger.report(entriIntroModal({
        ...commonParams,
        action_name: action,
        domain: domainName
      }));
    });
    EntriModule.SDK.setBiEvent('onIsEligibleForFlow', data => biLogger == null ? void 0 : biLogger.report(entriEligibilityLittleHelper({
      ...commonParams,
      domain: data.domainName,
      isEligible: data.isEligible
    })));
    EntriModule.SDK.setBiEvent('onEntriStepChange', data => biLogger == null ? void 0 : biLogger.report(entriStepView({
      ...commonParams,
      domain: data.domainName,
      stepName: data.step,
      provider: data.provider,
      errorMsg: data.error
    })));
    EntriModule.SDK.setBiEvent('onEntriExit', data => {
      var _data$result, _data$result2, _data$result3, _data$result4, _data$result5, _data$result6, _data$result7, _data$result8;
      biLogger == null || biLogger.report(entriFlowResult({
        ...commonParams,
        domain: data.domainName,
        isSuccess: (_data$result = data.result) == null || (_data$result = _data$result.exitDetails) == null ? void 0 : _data$result.success,
        errorMsg: (_data$result2 = data.result) == null ? void 0 : _data$result2.error,
        lastStep: (_data$result3 = data.result) == null || (_data$result3 = _data$result3.exitDetails) == null ? void 0 : _data$result3.lastStatus,
        provider: (_data$result4 = data.result) == null || (_data$result4 = _data$result4.checkDomainData) == null ? void 0 : _data$result4.provider,
        setupType: (_data$result5 = data.result) == null || (_data$result5 = _data$result5.checkDomainData) == null ? void 0 : _data$result5.setupType
      }));
      switch ((_data$result6 = data.result) == null ? void 0 : _data$result6.status) {
        case EntriFlowStatus.manual:
        case EntriFlowStatus.abort:
          biLogger == null || biLogger.report(entriFlowLeaveFunnel({
            ...commonParams,
            lastStep: (_data$result7 = data.result) == null || (_data$result7 = _data$result7.exitDetails) == null ? void 0 : _data$result7.lastStatus,
            action_type: ((_data$result8 = data.result) == null ? void 0 : _data$result8.status) === EntriFlowStatus.manual ? 'go_to_manual_setup' : 'close'
          }));
          break;
        default:
          break;
      }
    });

    // 17:1180 — TLD card clicked on the gate, before navigation
    DomainSearchGateModule.SDK.setBiEvent('onGateTldClick', params => {
      biLogger == null || biLogger.report(domainsGateClickOnTldSrc17Evid1180({
        ...gateEventContext,
        ...params,
        sitename,
        sitenameType
      }));
    });

    // 17:1181 — gate scroll depth threshold crossed
    DomainSearchGateModule.SDK.setBiEvent('onGateScroll', params => {
      biLogger == null || biLogger.report(domainsGateScrollSrc17Evid1181({
        ...gateEventContext,
        ...params
      }));
    });

    // 17:20100 — who is view
    DomainSearchGateModule.SDK.setBiEvent('onWhoisView', params => {
      biLogger == null || biLogger.report(whoIsViewSrc17Evid20100(params));
    });

    // 17:20103 — fires when user views WHOIS sections that loaded below the viewport
    DomainSearchGateModule.SDK.setBiEvent('onWhoisBelowFoldImpression', params => {
      biLogger == null || biLogger.report(whoIsAboveTheFoldImpressionSrc17Evid20103(params));
    });

    // 17:20101 — general whois action (accordion toggle, url click, ICANN complaint)
    DomainSearchGateModule.SDK.setBiEvent('onWhoisGeneralAction', params => {
      biLogger == null || biLogger.report(whoIsGeneralActionSrc17Evid20101(params));
    });

    // 17:20201 — BNG general action (tile select, generate more, regenerate, initial generate)
    DomainSearchGateModule.SDK.setBiEvent('onBngGeneralAction', params => {
      biLogger == null || biLogger.report(bngGeneralActionSrc17Evid20201(params));
    });

    // 17:20210 — BNG tooltip view (AI Insights popover opened on hover)
    DomainSearchGateModule.SDK.setBiEvent('onBngTooltipView', params => {
      biLogger == null || biLogger.report(bngViewModalSrc17Evid20210(params));
    });
    DomainSearchGateModule.SDK.setBiEvent('onBngBusinessNamesShown', params => {
      biLogger == null || biLogger.report(bngBusinessNamesShown(params));
    });
  }, [biLogger, viewMode, canPurchaseDomainSuite, getCommonParams, referralAdditionalInfo, reportGatePageLoadEvents, submittedFilters, useReferralAdditionalInfoAsSearchOrigin, deferResultsPageLoad, isResultsVisible, bngMobileSearchTerm, isGateLanding, isEmptyState, prefilledTld, isMobile, siteName]);
  useEffect(() => {
    if (viewMode) {
      DomainSearchSuiteModule.SDK.domainSearchSuiteStore.setViewMode(viewMode);
    }
  }, [viewMode]);
  return undefined;
};
//# sourceMappingURL=useDomainSearchGateBi.js.map